export default "__VITE_ASSET__dsDKEKZV__"